/* The public endpoint returns Google-formatted addresses: street, neighbourhood,
   city, state, CEP, country. The lead already knows the country and typed the CEP,
   so the tail is noise that pushes the useful part onto a second line. */
export const formatStationAddress = (raw: string): string =>
  raw
    .replace(/,\s*Brazil\s*$/i, '')
    .replace(/,\s*\d{5}-?\d{3}\s*$/, '')
    .replace(/\s+-\s+[A-Z]{2}\s*$/, '')
    .trim();
